<div class="row">
    <div class="col-12">
        <div class="content-header">Class Form</div>
    </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
    <div class="row">
        <div class="col-12">
            <div class="card">

                <div class="card-content">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md">
                                <form [formGroup]="classForm">
                                    <fieldset class="mb-3">
                                        <label>Batch<span class="required_field">*</span></label>
                                        <ng-select [items]="batch_list" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                                            [(ngModel)]="select_batch" [ngModelOptions]="{ standalone: true }"
                                            [closeOnSelect]="false" (change)="getBatchId($event)">
                                        </ng-select>
                                    </fieldset>
                                    <fieldset class="mb-3">
                                        <label>Course<span class="required_field">*</span></label>
                                        <ng-select [items]="course_list" bindLabel="title" bindValue="_id" placeholder="Select course"
                                            [(ngModel)]="select_course" [ngModelOptions]="{ standalone: true }"
                                            [closeOnSelect]="false" (change)="getCourseId($event)">
                                        </ng-select>
                                    </fieldset>
                                    <fieldset class="mb-3">
                                        <label>Students<span class="required_field">*</span></label>
                                        <ng-select [items]="student_list" bindLabel="name" bindValue="user_id" placeholder="Select Student"
                                            [(ngModel)]="select_student" [multiple]="true" [ngModelOptions]="{ standalone: true }"
                                            [closeOnSelect]="false" (change)="getStudentId($event)">
                                        </ng-select>
                                    </fieldset>
                                </form>
                            </div>
                            <div class="col-md">

                                <form [formGroup]="classForm">
                                    <fieldset class="form-group">
                                        <label>Topic Name</label>
                                        <ng-select [items]="topic_list" [multiple]="true" bindLabel="name" bindValue="_id" placeholder="Select topic"
                                        [(ngModel)]="select_topic" [multiple]="true" [ngModelOptions]="{ standalone: true }"
                                        [closeOnSelect]="false" (change)="getTopicId($event)">
                                    </ng-select>
                                    </fieldset>
                                    <fieldset class="form-group">
                                        <label for="path">Date<span class="required_field">*</span></label>
                                        <input type="date" class="form-control"  [(ngModel)]="class_model.date" formControlName="date" [ngModel]="class_model.date | date:'yyyy-MM-dd'" >
                                    </fieldset>
                                    <fieldset class="form-group">
                                        <label for="path">Time<span class="required_field">*</span></label>
                                        <input type="text" placeholder="Enter time" class="form-control"  [(ngModel)]="class_model.time" formControlName="time">
                                    </fieldset>

                                </form>
                            </div>
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                                <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">
                                    Submit
                                </button>
                                <button type="reset" class="btn btn-secondary" (click)="back()">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>